// Tabs for the BF material page. Cart and variant logic stay with Dawn's product-info.js.
(() => {
  const init = (root) => {
    if (root.dataset.bfTabsReady) return;
    root.dataset.bfTabsReady = 'true';
    const tabs = Array.from(root.querySelectorAll('[role="tab"]'));

    const select = (tab, focus) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', on);
        t.tabIndex = on ? 0 : -1;
        const panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    };

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => select(tab, false));
      tab.addEventListener('keydown', (e) => {
        const moves = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: tabs.length - 1 };
        if (!(e.key in moves)) return;
        e.preventDefault();
        select(tabs[(moves[e.key] + tabs.length) % tabs.length], true);
      });
    });
  };

  const run = () => document.querySelectorAll('[data-bf-tabs]').forEach(init);
  run();
  document.addEventListener('shopify:section:load', run);
})();
